<template>
    <div id="zpert">
        <div class="title">恭喜您完善信息成功</div>
        <div class="sub-title-wrap">
            <div class="text3">广联达斑马进度计划软件<span class="text41">全套学习视频</span>送给你</div>
            <div class="text4">免费听案例，学操作，考取技能鉴定证书</div>
            <div class="button1" @click="skip"><img style="margin-right: 5px;height: 16px" src="@/assets/images/video.png"/>点此观看学习视频</div>
        </div>
        <div class="erweima">
            <img src="@/assets/images/qrcode360.png" alt="">
            <div class="descript">扫码添加官方答疑群</div>
        </div>
    </div>
</template>

<script>
    import qrCode from '@/assets/images/qrcode4.jpg'
    export default {
        data() {
            return {
                qrCode
            }
        },
        methods: {
            /**
             * @Description: 跳转
             * @param {*}
             * @Date: 2022-04-27 17:38:45
             */
            skip() {
            // window.location.href = 'https://b.zpert.com/upload/client_home/buy.html'
                window.open(
                    // "https://zhibo.glodon.com/live/watch/m2p4b1bl",
                    "https://qr32.cn/EBpZyH",
                    "_blank"
                );
            },
        }
    }
</script>

<style scoped lang="scss">
#zpert {
    .title {
        margin-top: 20px;
    }
    .sub-title-wrap {
        margin-top: 20px;
        .text3 {
        font-size: 21px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #3C5055;
        line-height: 42px;
        .text41 {
          color: #F47241;
        }
      }
      .text4 {
        font-size: 21px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #3C5055;
        line-height: 42px;
      }
      .button1 {
        margin: 20px auto;
        width: 197px;
        height: 45px;
        background: rgba(67, 138, 254);
        box-shadow: 0px 13px 18px rgba(20, 143, 233, 0.23);
        opacity: 1;
        border-radius: 50px;
        line-height: 45px;
        text-align: center;
        color: #FFFFFF;
        cursor: pointer;
        }
    
    }
    .bold-title {
        margin-top: 20px;
    }
    .erweima {
        margin-top: 20px; 
        &>img {
            height: 150px;
            width: 150px;
        }
    }
    .descript {
      margin-top: 10px;   
      font-size: 14px;
      color: #838AA0;
    }
}
</style>